import { Button } from '@nexelem/components';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type ActionButtonProps = {
  isActive?: boolean;
  className?: string;
  disabled?: boolean;
  label?: string;
  Icon?: ReactNode;
  onClick?: () => void;
  to?: string;
  ariaLabel?: string;
};

export const ActionButton = ({
  Icon,
  onClick,
  to,
  ariaLabel,
  isActive,
  className,
  label,
  disabled,
}: ActionButtonProps) => {
  const LinkProps = to ? { component: Link, to } : { disabled };

  return (
    <Button
      {...LinkProps}
      aria-label={ariaLabel}
      className={clsx(isActive && 'bg-surface-focus-lighter text-text-focus', className)}
      StartIcon={Icon}
      variant="text"
      onClick={onClick}
    >
      {label}
    </Button>
  );
};
